import { Component } from '@angular/core';
import { TipoReporteMadr } from '../carga-reportes-madr/interfaces/tipo-reporte-madr.interface';
import { TranslateService } from '@ngx-translate/core';
import { ReportesMadrService } from '../carga-reportes-madr/services/reportes-madr.service';
import Swal from 'sweetalert2';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { lastValueFrom } from 'rxjs';
import { saveAs } from 'file-saver';

@Component({
    selector: 'app-consulta-reportes-madr',
    templateUrl: './consulta-reportes-madr.component.html',
    styleUrls: ['./consulta-reportes-madr.component.css'],
})
export class ConsultaReportesMadrComponent {
    anioSeleccionado: number | null = null;
    anioTemporal: number | null = null;
    mostrarModalAnio = false;
    reportes: TipoReporteMadr[] = [];
    anioActual = new Date().getFullYear();
    anios: number[] = Array.from(
        { length: this.anioActual - 2025 + 1 },
        (_, index) => 2025 + index
    );
    private apiUrl: string = environment.apiSiriUrl;

    constructor(
        private translate: TranslateService,
        private reportesMadrService: ReportesMadrService,
        private http: HttpClient
    ) {
        this.translate.setDefaultLang('es');
        this.translate.use('es');
    }

    ngOnInit(): void {
        this.obtenerTiposReporte();
    }

    obtenerTiposReporte(): void {
        this.reportesMadrService.obtenerTiposReporte().subscribe({
            next: (response) => {
                this.reportes = response.map((reporte) => ({
                    ...reporte,
                }));
            },
            error: (error) => {
                console.error(
                    'Error obteniendo los tipos de reporte MADR:',
                    error
                );
            },
        });
    }

    mostrarTexto(): void {
        Swal.fire({
            title: 'Recuerda:',
            icon: 'info',
            html: `
      <style>
        .tabla-informacion {
            width: 100%;
            border-collapse: collapse;
            text-align: left;
            font-size: 13px;
        }

        .tabla-informacion th,
        .tabla-informacion td {
            border-bottom: 1px solid #bdbdbd;
            padding: 7px 10px;
            vertical-align: middle;
        }

        .tabla-informacion th {
            font-weight: 700;
        }

        .tabla-informacion td:first-child {
            width: 30%;
            font-weight: 600;
        }

        .swal-informacion {
            width: 600px !important;
        }
      </style>
      <table class="tabla-informacion">
        <thead>
          <tr>
            <th><strong>CAMPO</strong></th>
            <th><strong>DESCRIPCIÓN</strong></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>TIPO_PRODUCTO</strong></td>
            <td>
              Hace referencia al grupo de producto:
              Acondicionadores, coadyuvantes, fertilizantes,
              Nutrición animal y plaguicidas.
            </td>
          </tr>
          <tr>
            <td><strong>SUBGRUPO</strong></td>
            <td>
              Identifica el tipo específico de insumo agropecuario
              dentro de un grupo principal, de acuerdo a su función
              en el cultivo.
            </td>
          </tr>
          <tr>
            <td><strong>FESPECIFICA</strong></td>
            <td>
              Describe la acción técnica o uso agronómico específico
              del insumo dentro del subgrupo.
            </td>
          </tr>
          <tr>
            <td><strong>NOMBRE_COMUN</strong></td>
            <td>
              Identifica el nombre estandarizado para productos que
              son semejantes y que recoge en su texto atributos
              como son su composición o ingrediente activo, y para
              estos últimos formulación y concentración.
            </td>
          </tr>
        </tbody>
      </table>
    `,
            confirmButtonText: 'OK',
            customClass: {
                popup: 'swal-informacion',
            },
        });
    }

    abrirModalAnio(): void {
        this.anioTemporal = this.anioSeleccionado;
        this.mostrarModalAnio = true;
    }

    cerrarModalAnio(): void {
        this.mostrarModalAnio = false;
    }

    continuarAnio(): void {
        if (!this.anioTemporal) {
            return;
        }

        this.anioSeleccionado = this.anioTemporal;
        this.cerrarModalAnio();
    }

    descargarReporte(reporteId: number): void {
        if (!this.anioSeleccionado) {
            Swal.fire(
                'Año requerido',
                'Por favor, selecciona un año antes de descargar el reporte.',
                'warning'
            );
            return;
        }

        this.reportesMadrService
            .descargarReporte(this.anioSeleccionado, reporteId)
            .subscribe({
                next: (response: HttpResponse<Blob>) => {
                    const archivo = response.body;

                    if (!archivo) {
                        Swal.fire(
                            'Error',
                            'No se recibió el archivo del reporte.',
                            'error'
                        );
                        return;
                    }

                    const fechaActual = new Date();
                    const dia = String(fechaActual.getDate()).padStart(2, '0');
                    const mes = String(fechaActual.getMonth() + 1).padStart(
                        2,
                        '0'
                    );
                    const anioDescarga = fechaActual.getFullYear();

                    const nombreArchivo = `reporte-madr-${reporteId}-anio-${this.anioSeleccionado}-${dia}-${mes}-${anioDescarga}.xlsx`;

                    const url = window.URL.createObjectURL(archivo);
                    const enlace = document.createElement('a');

                    enlace.href = url;
                    enlace.download = nombreArchivo;
                    enlace.click();

                    window.URL.revokeObjectURL(url);
                },
                error: async (error) => {
                    console.error('Error descargando reporte MADR:', error);

                    if (error.status === 400 && error.error instanceof Blob) {
                        const texto = await error.error.text();

                        try {
                            const respuesta = JSON.parse(texto);

                            Swal.fire(
                                'Reporte no disponible',
                                `No se encontró información disponible para el reporte seleccionado en el año ${this.anioSeleccionado}.`,
                                'warning'
                            );
                        } catch {
                            Swal.fire(
                                'Reporte no disponible',
                                'No existe información disponible para el reporte seleccionado.',
                                'warning'
                            );
                        }

                        return;
                    }

                    Swal.fire(
                        'Error',
                        'Ocurrió un error al descargar el reporte.',
                        'error'
                    );
                },
            });
    }

    async descargarFicha() {
        try {
            const pdf = await lastValueFrom(
                this.http.get(`${this.apiUrl}reportes-madr/descargar-ficha`, {
                    responseType: 'blob',
                })
            );

            saveAs(pdf, 'Guia_Lectura_Reportes_Siriiagro.pdf');
        } catch (error) {
            console.error('Error al descargar la guía de lectura', error);

            Swal.fire({
                title: 'Error',
                text: 'No fue posible descargar la guía de lectura. Inténtalo nuevamente más tarde.',
                icon: 'error',
            });
        }
    }
}
